import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import FTheader from "../Flashtoken/Component/header";
import Footer from "../Flashtoken/Component/Footer";
import { Languagemodel } from "../../Slice/translateSlice";
import "../Flashtoken/index.css";
import "./index.css";

const LOGOS = [
  {
    key: "coin",
    title: "Official coin",
    preview: "/brand/flash-coin.svg",
    theme: "dark",
    files: [
      { label: "SVG", href: "/brand/flash-coin.svg" },
      { label: "PNG 256", href: "/brand/flash-coin-256.png" },
      { label: "PNG 512", href: "/brand/flash-coin-512.png" },
      { label: "PNG 1024", href: "/brand/flash-coin-1024.png" },
    ],
  },
  {
    key: "icon",
    title: "Icon",
    preview: "/brand/flash-icon.svg",
    theme: "dark",
    files: [
      { label: "SVG", href: "/brand/flash-icon.svg" },
      { label: "PNG 256", href: "/brand/flash-icon-256.png" },
      { label: "PNG 512", href: "/brand/flash-icon-512.png" },
      { label: "PNG 1024", href: "/brand/flash-icon-1024.png" },
    ],
  },
  {
    key: "black",
    title: "Icon black",
    preview: "/brand/flash-icon-black.svg",
    theme: "light",
    files: [
      { label: "SVG", href: "/brand/flash-icon-black.svg" },
      { label: "PNG 256", href: "/brand/flash-icon-black-256.png" },
      { label: "PNG 512", href: "/brand/flash-icon-black-512.png" },
    ],
  },
  {
    key: "white",
    title: "Icon white",
    preview: "/brand/flash-icon-white.svg",
    theme: "dark",
    files: [
      { label: "SVG", href: "/brand/flash-icon-white.svg" },
      { label: "PNG 256", href: "/brand/flash-icon-white-256.png" },
      { label: "PNG 512", href: "/brand/flash-icon-white-512.png" },
    ],
  },
  {
    key: "lockup",
    title: "Lockup",
    preview: "/brand/flash-lockup.svg",
    theme: "dark",
    files: [
      { label: "SVG dark", href: "/brand/flash-lockup.svg" },
      { label: "SVG light", href: "/brand/flash-lockup-light.svg" },
    ],
  },
  {
    key: "wordmark",
    title: "Wordmark",
    preview: "/brand/flash-wordmark.svg",
    theme: "dark",
    files: [
      { label: "SVG white", href: "/brand/flash-wordmark.svg" },
      { label: "SVG dark", href: "/brand/flash-wordmark-dark.svg" },
    ],
  },
];

const COLORS = [
  { name: "Gold", hex: "#FBBF04" },
  { name: "Gold highlight", hex: "#FFE08A" },
  { name: "Gold deep", hex: "#C98A00" },
  { name: "Black", hex: "#0F0F0F" },
  { name: "Surface", hex: "#181818" },
  { name: "Muted", hex: "#85898F" },
  { name: "White", hex: "#FFFFFF" },
];

const MEDIA = [
  { name: "Bloomberg", href: "https://www.bloomberg.com/press-releases/2023-04-04/flash-technologies-is-set-to-revolutionize-the-money-transfer-market" },
  { name: "Benzinga", href: "https://www.benzinga.com/pressreleases/23/04/g31662539/flash-technologies-is-set-to-revolutionize-the-money-transfer-market" },
  { name: "Yahoo Finance", href: "https://finance.yahoo.com/news/flash-technologies-set-revolutionize-money-170000615.html" },
  { name: "Binance", href: "https://www.binance.com/en/feed/post/221737" },
  { name: "Cointelegraph", href: "https://fr.cointelegraph.com/press-releases/flash-technologies-is-set-to-revolutionize-the-money-transfer-market" },
  { name: "TradingView", href: "https://www.tradingview.com/news/reuters.com,2023-04-04:newsml_GNX2nycJb:0/" },
  { name: "Cointribune", href: "https://www.cointribune.com/flash-technologies" },
];

function t(lang, key, fallback) {
  return lang[key] || fallback;
}

export default function PressPage() {
  const lang = useSelector(Languagemodel);
  const [copied, setCopied] = useState("");

  useEffect(() => {
    document.title = `${t(lang, "Press & Brand Kit", "Press & Brand Kit")} | Flash Technologies`;
    window.scrollTo(0, 0);
    return () => {
      document.title = "Flash Technologies | Flash Transfer - Financial freedom is on the way";
    };
  }, [lang]);

  const copyText = async (value, id) => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(id);
      window.setTimeout(() => setCopied(""), 1800);
    } catch {
      setCopied("");
    }
  };

  const boilerplate = t(
    lang,
    "Press boilerplate text",
    "Flash Technologies builds a money-transfer ecosystem: Flash Transfer lets people buy, send, or cash out crypto through a merchant network; Flash Wallet is a non-custodial wallet with a dead-wallet smart contract; Flash Dex aggregates swap and bridge routes. Offices in Dubai, Paris, and Abidjan."
  );

  return (
    <>
      <FTheader />
      <main className="press-kit">
        <div className="press-kit__inner">
          <p className="press-kit__eyebrow">{t(lang, "Press", "Press")}</p>
          <h1 className="press-kit__title">
            {t(lang, "Press & Brand Kit", "Press & Brand Kit")}
          </h1>
          <p className="press-kit__lead">
            {t(
              lang,
              "Press kit intro",
              "Official logos, colors, and copy for journalists, partners, and creators. Use these files as-is — do not redraw the Flash coin."
            )}
          </p>
          <div className="press-kit__hero-actions">
            <a className="press-kit__btn press-kit__btn--gold" href="/brand/flash-brand-kit.zip" download>
              {t(lang, "Download brand kit", "Download brand kit")}
            </a>
            <a className="press-kit__btn press-kit__btn--ghost" href="mailto:media@flash-technologies.org">
              media@flash-technologies.org
            </a>
          </div>

          <section className="press-kit__section" id="logos">
            <h2>{t(lang, "Logos", "Logos")}</h2>
            <p className="press-kit__section-lead">
              {t(
                lang,
                "Logos intro",
                "Prefer SVG. Use the gold coin on dark backgrounds. Mono versions are for one-color print."
              )}
            </p>
            <div className="press-kit__grid">
              {LOGOS.map((item) => (
                <article className="press-kit__card" key={item.key}>
                  <div className={`press-kit__preview press-kit__preview--${item.theme}`}>
                    <img src={item.preview} alt={t(lang, item.title, item.title)} />
                  </div>
                  <h3>{t(lang, item.title, item.title)}</h3>
                  <div className="press-kit__downloads">
                    {item.files.map((file) => (
                      <a
                        key={file.href}
                        className="press-kit__dl"
                        href={file.href}
                        download
                      >
                        {file.label}
                      </a>
                    ))}
                  </div>
                </article>
              ))}
            </div>
          </section>

          <section className="press-kit__section" id="colors">
            <h2>{t(lang, "Colors", "Colors")}</h2>
            <p className="press-kit__section-lead">
              {t(lang, "Colors intro", "Click a swatch to copy the hex value.")}
            </p>
            <div className="press-kit__colors">
              {COLORS.map((color) => (
                <button
                  type="button"
                  className="press-kit__swatch"
                  key={color.hex}
                  onClick={() => copyText(color.hex, color.hex)}
                >
                  <div
                    className="press-kit__swatch-chip"
                    style={{ background: color.hex }}
                  />
                  <div className="press-kit__swatch-meta">
                    <strong>{t(lang, color.name, color.name)}</strong>
                    <span>{copied === color.hex ? t(lang, "Copied", "Copied") : color.hex}</span>
                  </div>
                </button>
              ))}
            </div>
          </section>

          <section className="press-kit__section" id="type">
            <h2>{t(lang, "Typography", "Typography")}</h2>
            <p className="press-kit__section-lead">
              {t(lang, "Typography intro", "Manrope is the Flash typeface — ExtraBold for titles, Regular for body.")}
            </p>
            <div className="press-kit__type">
              <div className="press-kit__type-row">
                <small>Manrope ExtraBold · 56</small>
                <p style={{ fontWeight: 800, fontSize: "clamp(28px, 4vw, 48px)" }}>
                  Flash Technologies
                </p>
              </div>
              <div className="press-kit__type-row">
                <small>Manrope Regular · 18</small>
                <p style={{ fontWeight: 400, fontSize: 18, color: "#b8bcc2" }}>
                  {t(
                    lang,
                    "Typography sample",
                    "Financial freedom is on the way."
                  )}
                </p>
              </div>
            </div>
          </section>

          <section className="press-kit__section" id="usage">
            <h2>{t(lang, "Usage", "Usage")}</h2>
            <div className="press-kit__rules">
              <div className="press-kit__rule press-kit__rule--do">
                <h3>{t(lang, "Do", "Do")}</h3>
                <ul>
                  <li>{t(lang, "Usage do 1", "Use official files from this kit")}</li>
                  <li>{t(lang, "Usage do 2", "Keep the bolt black on the gold coin")}</li>
                  <li>{t(lang, "Usage do 3", "Leave clear space around the logo")}</li>
                  <li>{t(lang, "Usage do 4", "Use #FBBF04 as the only brand yellow")}</li>
                </ul>
              </div>
              <div className="press-kit__rule press-kit__rule--dont">
                <h3>{t(lang, "Don't", "Don't")}</h3>
                <ul>
                  <li>{t(lang, "Usage dont 1", "Do not recolor, outline, or add shadows")}</li>
                  <li>{t(lang, "Usage dont 2", "Do not rotate, stretch, or crop the coin")}</li>
                  <li>{t(lang, "Usage dont 3", "Do not place the gold coin on yellow")}</li>
                  <li>{t(lang, "Usage dont 4", "Do not replace the bolt with another symbol")}</li>
                </ul>
              </div>
            </div>
          </section>

          <section className="press-kit__section" id="boilerplate">
            <h2>{t(lang, "Press boilerplate", "Press boilerplate")}</h2>
            <div className="press-kit__boilerplate">
              <p>{boilerplate}</p>
              <button
                type="button"
                className="press-kit__btn press-kit__btn--ghost"
                onClick={() => copyText(boilerplate, "copy")}
              >
                {copied === "copy" ? t(lang, "Copied", "Copied") : t(lang, "Copy", "Copy")}
              </button>
            </div>
          </section>

          <section className="press-kit__section" id="media">
            <h2>{t(lang, "Seen in the media", "Seen in the media")}</h2>
            <div className="press-kit__media">
              {MEDIA.map((item) => (
                <a key={item.href} href={item.href} target="_blank" rel="noreferrer">
                  {item.name}
                </a>
              ))}
            </div>
          </section>

          <section className="press-kit__section press-kit__contact" id="press-contact">
            <h2>{t(lang, "Press contact", "Press contact")}</h2>
            <p className="press-kit__section-lead">
              {t(lang, "Press contact intro", "For interviews, assets, or partnership mentions:")}{" "}
              <a href="mailto:media@flash-technologies.org">media@flash-technologies.org</a>
            </p>
          </section>
        </div>
      </main>
      <div className="press-kit__footer-wrap">
        <Footer />
      </div>
    </>
  );
}
